<template>
  <ul class="list-group">
    <li v-for="node in treeNodes"
        class="list-group-item node-basicTree">
      <div class="wrapper">
        <span class="icon node-icon"></span>
        <a v-on:click="_nodeClick(node, $event)" href="#">
          {{ node.NAME }}
        </a>
        <span v-if="node.hasOwnProperty('SUBTREE') && node.SUBTREE && node.SUBTREE.length"
              v-on:click="_openSubTree($event)"
              class="icon expand-icon wb-plus plus-minus"></span>
      </div>
      <!--        <span class="items-count">5</span>-->
      <tree-node
        v-if="node.hasOwnProperty('SUBTREE') && node.SUBTREE && node.SUBTREE.length"
        :treeNodes="node.SUBTREE"
        @changeNode="_changeNodeListener"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'tree-node',

  props: [
    'treeNodes'
  ],

  methods: {

    /**
     *
     * @param event
     * @private
     */
    _openSubTree (event) {
      let $this = $(event.target)
      $this.closest('li').find('ul').first().toggle()
      if ($this.hasClass('wb-plus')) {
        $this.removeClass('wb-plus')
        $this.addClass('wb-minus')
      }
      else {
        $this.removeClass('wb-minus')
        $this.addClass('wb-plus')
      }
    },

    /**
     *
     * @param node
     * @param event
     * @private
     */
    _nodeClick (node, event) {
      event.preventDefault()

      let $this = $(event.target)
      let items = $this.closest('.categorie-treeview').find('.active-node')
      items.each((index, item) => {
        $(item).removeClass('active-node')
      })
      $this.addClass('active-node')

      this.$emit('changeNode', node)
    },

    /**
     *
     * @param treeNode
     * @private
     */
    _changeNodeListener (treeNode) {
      this.$emit('changeNode', treeNode)
    }
  }
}
</script>

<style scoped>
.list-group {
  padding-right: 0;
}

.list-group ul {
  margin: 8px 0 0 0;
  padding: 0;
  display: none;
}

.list-group ul li {
  padding: 9px 0px 9px 10px;
}

.list-group ul li .icon {
  right: 0px;
}

.list-group .icon {
  top: 8px;
}

ul li a {
  color: #37474f;
}

.active-node {
  color: #49aadf;
}

</style>
